import React from 'react';
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import {defaults} from 'lib.common';

/**
 * Propiedades no especificadas pertenecen https://v4.mui.com/api/form-control/#formcontrol-api
 * @param {*} param0
 * @returns
 */
function RadioGroupDs({
   error,
   helperText,
   formHelperTextClassName,
   formHelperTextProps,
   label,
   formLabelClassName,
   formLabelProps,
   options,
   value,
   onValueChange,
   getRadioLabel,
   getRadioId,
   radioClassName,
   radioProps,
   formControlClassName,
   ...formControlProps
}) {
   const valueId = getRadioId(value);
   return (
      <FormControl component="fieldset" error={error} hiddenLabel={!label} {...formControlProps}>
         <FormLabel className={formLabelClassName} component="legend" {...formLabelProps}>
            {label}
         </FormLabel>
         {options.map(currOption => {
            const currId = getRadioId(currOption);
            const currLabel = getRadioLabel(currOption);
            return (
               <FormControlLabel
                  checked={currId === valueId}
                  key={currId}
                  value={currId}
                  control={
                     <Radio
                        className={radioClassName}
                        onChange={() => {
                           onValueChange(currOption);
                        }}
                        {...radioProps}
                     />
                  }
                  label={currLabel}
               />
            );
         })}
         <FormHelperText className={formHelperTextClassName} error={error} {...formHelperTextProps}>
            {helperText}
         </FormHelperText>
      </FormControl>
   );
}
RadioGroupDs.propTypes = {
   error: PropTypes.bool,
   helperText: PropTypes.string,
   formHelperTextClassName: PropTypes.string,
   /**
    * https://v4.mui.com/api/form-helper-text/#formhelpertext-api
    */
   formHelperTextProps: PropTypes.object,
   label: PropTypes.string,
   formLabelClassName: PropTypes.string,
   /**
    * https://v4.mui.com/api/form-label/#formlabel-api
    */
   formLabelProps: PropTypes.object,
   options: PropTypes.arrayOf(PropTypes.any).isRequired,
   value: PropTypes.any.isRequired,
   onValueChange: PropTypes.func.isRequired,
   getRadioLabel: PropTypes.func,
   getRadioId: PropTypes.func,
   radioClassName: PropTypes.string,
   /**
    * https://v4.mui.com/components/radio-buttons/#radio
    */
   radioProps: PropTypes.object,
   formControlClassName: PropTypes.string
};
RadioGroupDs.defaultProps = {
   error: false,
   helperText: '',
   label: '',
   getRadioLabel: defaults.retornoMismoValor,
   getRadioId: defaults.retornoMismoValor
};
export default RadioGroupDs;
